import { createI18n } from 'vue-i18n';
import i18nMessages from 'dashboard/i18n';

const i18n = createI18n({
  legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
  locale: 'en',
  fallbackLocale: 'en',
  messages: i18nMessages,
});

export default i18n;
